var _ = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);
module.exports = function(data){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 var attrs = (data.container) ? data.schema.container : data.schema.source 
__p+='\n\n';
 if (data.container) { 
__p+='\n<h3>Container '+
((__t=( data.order - 1 ))==null?'':__t)+
'</h3>\n';
 } 
__p+='\n\n';
 _.each(attrs, function (value, key) { 
__p+='\n<p class="citation-field '+
((__t=( data.classNames[key] ))==null?'':__t)+
'" data-name="'+
((__t=( key ))==null?'':__t)+
'">\n  <label for="container-title-'+
((__t=( data.order ))==null?'':__t)+
'">'+
((__t=( value.name ))==null?'':__t)+
'<span class="punctuation">'+
((__t=( value.punctuation ))==null?'':__t)+
'</span></label>\n  <span id="container-title-'+
((__t=( data.order ))==null?'':__t)+
'" class="field-value">'+
((__t=( data[key] ))==null?'':__t)+
'</span>\n  <span data-lity-image="'+
((__t=( data.images[key] ))==null?'':__t)+
'" class="image-link"></span>\n</p>\n';
 }); 
__p+='\n';
return __p;
};
